import CreateSeedAudienceAdPlatform from './CreateSeedAudiencesAdPlatform.Container';

export default CreateSeedAudienceAdPlatform;
